import Vue from 'vue'
import Vuex from 'vuex'

import { state } from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import scssVariables from './modules/scssVariables'

import authModule from './modules/auth'
import dictionaryModule from './modules/dictionaries'
import signalR from './modules/signalR'
import signalRDeviceCommand from './modules/signalRDeviceCommand'
import trackingModule from './modules/tracking'
import mediaModule from './modules/media'
import brandModule from './modules/brand'
import layoutModule from './modules/layout'
import filterModule from './modules/filter'
import managementTables from './modules/managementTables'
import organizationTreeModule from './modules/organizationTree'
import activeOrganizationData from '@/store/modules/activeOrganizationData'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        authModule,
        layoutModule,
        dictionaryModule,
        signalR,
        signalRDeviceCommand,
        scssVariables,
        trackingModule,
        mediaModule,
        brandModule,
        filterModule,
        managementTables,
        organizationTreeModule,
        activeOrganizationData
    },
    state: () => state,
    getters,
    mutations,
    actions
})
